export default "__VITE_ASSET__CcXKpbju__"